'use strict';

angular.module('DoohApps')
    .directive('scrollHorizontal', [function scrollHorizontalDirective() {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.mousewheel(function (e, delta) {
                    this.scrollLeft -= (delta * 60);
                    detectEnd(delta > 0, delta * 60);
                    e.preventDefault();
                    e.stopPropagation();
                });

                function detectEnd(isLeft, offset) {
                    if (!isLeft)
                        offset = - offset;

                    var newScrollLeft = elem.scrollLeft(),
                        width = elem.width(),
                        scrollWidth = elem.get(0).scrollWidth;

                    var res = scrollWidth - newScrollLeft - width;
                    $('.scrollLeft').removeClass('scrollBtnDisable');
                    $('.scrollRight').removeClass('scrollBtnDisable');
                    elem.addClass('more-items-right');
                    elem.addClass('more-items-left');

                    if (res < offset) {
                        $('.scrollRight').addClass('scrollBtnDisable');
                        elem.removeClass('more-items-right');
                    }
                    if (newScrollLeft <= 0) {
                        $('.scrollLeft').addClass('scrollBtnDisable');
                        elem.removeClass('more-items-left');
                    }

                }
            }
        }
    }]);